import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from './constants';
import { Vertical } from 'types/vertical';

const url = `${baseApiUrl()}/lexiverse/verticals/v1/verticals`;

export const getVerticals = async (onError?: (errors: ServerErrorResponse) => void) => {
  try {
    const data = await fetcher({
      method: 'get',
      url,
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useVerticals(options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<Vertical[], ServerErrorResponse>(['verticals'], async () => getVerticals(onError), {
    keepPreviousData: false,
    ...options,
  });
}
